import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import CollectionsIcon from '@mui/icons-material/Collections';
import BookmarkBorderOutlinedIcon from '@mui/icons-material/BookmarkBorderOutlined';

const useMediaContentTabs = () => {
  const { t } = useTranslation('activ8');

  const tabs = useMemo(
    () => [
      {
        label: (
          <>
            <CollectionsIcon fontSize='small' sx={{ mr: 0.5 }} />
            {t('generated')}
          </>
        ),
        value: 0,
      },
      {
        label: (
          <>
            <BookmarkBorderOutlinedIcon fontSize='small' sx={{ mr: 0.5 }} />
            {t('favorites')}
          </>
        ),
        value: 1,
      },
    ],
    [t],
  );

  return tabs;
};

export default useMediaContentTabs;
